export const LEFT = 'left';
export const RIGHT = 'right';
export const CENTER = 'center';

export type TextAlign = typeof LEFT | typeof RIGHT | typeof CENTER;

class TextBoxRef {
  constructor(readonly value: string, readonly textAlign: TextAlign) {}

  static create = (...args: ConstructorParameters<typeof TextBoxRef>) =>
    new TextBoxRef(...args);
}

export default TextBoxRef;
